// extracted by mini-css-extract-plugin
export default {"container":"ProductCarbonFootprintSection_container__ILksz","card":"ProductCarbonFootprintSection_card__6Mi9l"};